import React from "react";
import "../styles/Clientes.css";

const Clientes = ({ title, clientesData }) => {
  return (
    <section className="clientes">
      <h2>{title}</h2>
      <div className="clientes-container">
        {clientesData.map((cliente) => (
          <div key={cliente.id} className="cliente-logo">
            {cliente.link ? (
              <a href={cliente.link} target="_blank" rel="noopener noreferrer">
                <img src={cliente.src} alt={cliente.alt} />
              </a>
            ) : (
              <img src={cliente.src} alt={cliente.alt} />
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Clientes;
